import { Component, OnChanges, Input } from "@angular/core";

import { AssemblyConfig, APIResults } from "src/app/sharedinterfaces";
import { ApiService } from "src/app/api.service";

@Component({
	selector: "app-mech-maintenance",
	templateUrl: "./mech-maintenance.component.html",
	styleUrls: ["./mech-maintenance.component.scss"]
})
export class MechMaintenanceComponent implements OnChanges {
	@Input()
	asset: APIResults.FleetAsset;
	@Input()
	fleet: APIResults.Fleet;
	@Input()
	components: APIResults.AssetComponentList;

	public logs: APIResults.MaintenanceHistory[];

	public allLRUs: AssemblyConfig.LRUDef[];

	/** Date of new maintenance op, only for fixed assets */
	public newDate: string;
	public operations: APIResults.Operation[];
	public selectedOperation: APIResults.Operation;
	public newLRU: AssemblyConfig.LRUDef;
	public newSummary: string;

	constructor(public api: ApiService) { }

	async ngOnChanges() {
		this.allLRUs = [{
			id: null,
			name: "A/C (all components)",
		}, ...this.components.lru];
		this.newLRU = this.allLRUs[0];
		this.updateLogs();
		this.updateOperations();
	}

	async updateLogs() {
		this.logs = undefined;
		const result = await this.api.GetMaintenanceHistory(this.asset.asset_id);
		this.logs = result;
	}

	async updateOperations() {
		this.operations = undefined;
		const operations = await this.api.GetOperationsWithEnd(this.asset.asset_id, 800);
		this.operations = operations;
		if (this.operations.length > 0) {
			this.selectedOperation = this.operations[0];
		}
	}

	lookupLRU(id: number) {
		const lru = this.allLRUs.find(item => item.id === id);
		if (lru) {
			return lru.name;
		}
		return "????";
	}

	async UploadMaintenance() {
		let ts;
		if (this.asset.is_fixed) {
			ts = this.newDate + "Z";
		} else {
			ts = this.selectedOperation.end_time.toISOString()
		}
		await this.api.UploadMaintenance(this.asset.asset_id, ts, this.newLRU.id, this.newSummary);
		await this.updateLogs();
		this.newSummary = undefined;
	}

	async DeleteMaintenance(id: number) {
		await this.api.DeleteMaintenance(this.asset.asset_id, id);
		await this.updateLogs();
	}
}
